import { Box, Stack, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

export interface TagResultSectionProps {
    dense?: boolean;
    icon?: React.ReactNode;
    title: string;
}

export function TagResultSection({ children, dense, icon, title }: Readonly<PropsWithChildren<TagResultSectionProps>>) {
    return (
        <Stack spacing={dense ? 1 : 1.5}>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                {icon ? <Box sx={{ alignItems: 'center', display: 'flex' }}>{icon}</Box> : null}
                <Typography variant={dense ? 'subtitle2' : 'subtitle1'}>{title}</Typography>
            </Stack>
            {children}
        </Stack>
    );
}
